import React from 'react';
import { useWeeklyChallenge } from 'src/app/hooks/useWeeklyChallenge';
import { WeekChallengeCountdownTimer } from '@/app/screens/week-challenge/week-challenge-modal/week-challenge-countdown-timer';
import { DuelsPlayerQuestion } from './duels-player-question';
import { ChallengeModalHeader, ChallengeModalHeaderContent, ChallengeModalSection, ChallengeModalSubtitle, ChallengeModalTitle } from '@/components/custom/challenge';

export function DuelsPlayerStepQuestion() {
  const { currentRound, currentChallenge } = useWeeklyChallenge();

  return (
    <ChallengeModalSection variant="question">
      <ChallengeModalHeader>
        <ChallengeModalHeaderContent>
          <ChallengeModalTitle>{currentChallenge?.['parent-taxonomy']?.name}</ChallengeModalTitle>
          <ChallengeModalSubtitle>Rodada {currentRound}</ChallengeModalSubtitle>
        </ChallengeModalHeaderContent>

        <WeekChallengeCountdownTimer className="shrink-0" />
      </ChallengeModalHeader>

      <DuelsPlayerQuestion />
    </ChallengeModalSection>
  );
}
